import React from 'react';
import { toolGroups } from '../../data/tools';
import { HoleIcon, HollowIcon, LabelIcon, LayoutIcon, OneClickIcon, OrientIcon, ProtectIcon, SizeIcon, SupportIcon, TextureIcon } from '../icons/ToolIcons';
import type { ToolId } from '../../types/tools';
const icons: Record<ToolId, React.ComponentType<{
  className?: string;
}>> = {
  oneclick: OneClickIcon,
  size: SizeIcon,
  protect: ProtectIcon,
  orient: OrientIcon,
  support: SupportIcon,
  layout: LayoutIcon,
  hollow: HollowIcon,
  texture: TextureIcon,
  label: LabelIcon,
  hole: HoleIcon
};
type ToolRailProps = {
  active: ToolId | null;
  onSelect: (tool: ToolId) => void;
  dimmed?: boolean;
};
export function ToolRail({
  active,
  onSelect,
  dimmed = false
}: ToolRailProps) {
  return <nav aria-label="Tools" className={`flex w-[38px] shrink-0 flex-col gap-[6px] transition-opacity duration-150 ${dimmed ? 'opacity-50 [&_button]:!bg-white [&_button]:!text-[#2f343a] [&_span]:!text-[#3d4248]' : ''}`} data-id="element-67" data-mp="2grg1k2mg0t75">
      
      {toolGroups.map((group, i) => <div key={i} className="overflow-hidden rounded-[6px] bg-white shadow-[0_1px_4px_rgba(20,28,38,0.14)]" data-id="element-68" data-mp="2fdmv49cqp2b6" data-mpi={i}>
          {group.map(tool => {
        const Icon = icons[tool.id];
        const isActive = active === tool.id;
        return <button key={tool.id} type="button" aria-pressed={isActive} onClick={() => onSelect(tool.id)} className={`flex h-[37px] w-full flex-col items-center justify-center gap-[2px] transition-colors duration-150 ${isActive ? 'bg-[#cfe0f4] text-pf-blue' : 'text-[#2f343a] hover:bg-pf-panel'}`} data-id="element-69" data-mp="20q1uqn791h6y">
              
                <Icon className="h-[17px] w-[17px]" data-id="element-70" data-mp="1hrpjmvws1x8q" />
                <span className={`text-[8.5px] leading-none ${isActive ? 'text-pf-blue' : 'text-[#3d4248]'}`} data-id="element-71" data-mp="1ht0mmtief0ys">{tool.label}</span>
              </button>;
      })}
        </div>)}
    </nav>;
}